<div class="content__inner">
    <header class="content__title">
        <h1>{{ "flyerimages.list.title" | translate }}</h1>
        <small>{{ "flyerimages.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'FLYERIMAGES.ADD'" (click)="addFlyerImage()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "flyerimages.list.add" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'FLYERIMAGES.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "flyerimages.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "flyerimages.props._id" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row._id }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "flyerimages.props.description" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
                    </ng-container>

                    <ng-container matColumnDef="filename">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "flyerimages.props.filename" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.filename }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "flyerimages.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "flyerimages.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="editFlyerImage(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'FLYERIMAGES.EDIT'"></i>
                            <i (click)="deleteFlyerImage(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'FLYERIMAGES.DELETE'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
